import {Injectable} from '@angular/core';
import {first, Observable, of, switchMap} from 'rxjs';
import {
  EdiPurchaseOrder,
  GungEdimessageType
} from '../../models/edi';
import {
  EdiMessageBaseActionConfigService
} from '../edi-message-base-action-config/edi-message-base-action-config.service';
import {ActionButtonConfigService} from 'gung-common';

@Injectable({
  providedIn: 'root'
})
export class EdiPurchasedOrderActionConfigService
  extends EdiMessageBaseActionConfigService
  implements ActionButtonConfigService<EdiPurchaseOrder> {

  protected getMessageType(): GungEdimessageType {
    return GungEdimessageType.PURCHASE_ORDER;
  }
}
